<template>
    <div class="flexContainer full">
        <ModalBasket v-if="displayBasket" @hideBasketModal="modalClose"></ModalBasket>
        <section id="catalog" class="flexContainer t-fd-c fd-c full">
            <!-- version DESKTOP -->
            <section class="catalogWrapper flexContainer t-jc-sb jc-sb mobileNot">
                <aside class="searchBar tabletNot size1of4 flexContainer t-fd fd-c rel">
                    <div
                        @click="updateQuery({});"
                        class="btnExp primary-text primary-border-color iBlock pointer clear mobileNot txtCenter"
                        :class="{ active: this.$route.query.type || this.$route.query.category }"
                    >
                        {{ $t("catalogue.clear") }}
                    </div>
                    <Picker
                        @updateQuery="updateQuery"
                        :getLinkParams="getLinkParams"
                        :getRouteParams="getRouteParams"
                        :categories="categories"
                        :systemTypes="systemTypes"
                        :sections="sections"
                        :types="types"
                        :standDesigns="standDesigns"
                        :status="status"
                    ></Picker>
                </aside>
                <!-- content -->
                <div class="fixed sortContainer full">
                    <div class="flexContainer m-jc-sa sortFilter tabletOnly uppercase" id="filterMobile">
                        <p class="pointer" @click="showFilters">{{ $t("catalogue.filter") }}</p>
                    </div>
                </div>
                <section class="searchResultsWrapper rel size3of4 flexContainer fd-c t-fd-c m-fd-c t-ai-s">
                    <loader :position="'fixed'" :spinLeft="'60%'" :loading="loader"></loader>
                    <header class="queryWrapper flexContainer fd-c t-fd-c">
                        <div class="queryResults ff-medium primary-text">
                            <div class="queryResults ff-medium">
                                {{ $t("catalogue.weFound") }}
                                <span class="ff-light" :style="'color:' + getBrandColor + ';'">
                                    <span class="ff-medium returned" v-if="typeof routeParams.search !== 'undefined'"
                                        >&nbsp;{{ $t("catalogue.for") }}
                                        <span class="ff-black" :style="'color:' + getBrandColor + ';'">{{ routeParams.search }} </span>
                                    </span>
                                    <span class="ff-medium returned" style="font-size:16px;">{{ $t("catalogue.return") }}</span>
                                    <span class="ff-black" style="font-size:16px;">{{ getMetaTotal }}</span></span
                                >
                                {{ $t("catalogue.results") }}
                            </div>
                            <ClientColorButton v-if="showForecastAddButton" @click="addSelectionToForecasts" style="margin-top: 10px;"
                                >add filtered selection to forecast&nbsp;&nbsp;<ForecastIcon :color="'#fff'" style="height: 15px;"
                            /></ClientColorButton>
                        </div>
                        <div class="hidden">filters</div>

                        <div class="flexContainer jc-sb">
                            <div></div>
                            <div></div>
                            <div class="pagination"><Pagination :componentName="'Catalog'" :meta="getMeta" :page="currentPage"></Pagination></div>
                        </div>
                    </header>
                    <section class="resultsWrapper">
                        <div class="row">
                            <ComponentListItem
                                :page="'catalogue'"
                                :key="item.id"
                                v-for="(item, index) in getVueResults"
                                :index="index"
                                :item="item"
                                :device="'desktop'"
                            ></ComponentListItem>
                        </div>
                    </section>
                    <div class="flexContainer jc-sb">
                        <div></div>
                        <div></div>
                        <div class="pagination"><Pagination :componentName="'Catalog'" :meta="getMeta" :page="currentPage"></Pagination></div>
                    </div>
                </section>
            </section>

            <!-- version MOBILE -->
            <section class="catalogWrapper mobileOnly tabletNot flexContainer m-fd-r rel">
                <div class="fixed sortContainer full">
                    <div class="flexContainer m-jc-sa sortFilter uppercase">
                        <p class="pointer" @click="showFilters">{{ $t("catalogue.filter") }}</p>
                    </div>
                </div>
                <section class="searchResultsWrapper flexContainer full t-fd-c fd-c t-ai-s">
                    <header class="queryWrapper flexContainer t-fd-c fd-c">
                        <div class="queryResults ff-medium">
                            {{ $t("catalogue.weFound") }}
                            <span v-if="typeof routeParams.search !== 'undefined'"
                                >{{ $t("catalogue.for") }}
                                <span class="ff-light" :style="'color:' + getBrandColor + ';'"> {{ routeParams.search }}</span>
                            </span>
                            <span class="ff-light" :style="'color:' + getBrandColor + ';'">
                                <span class=" ff-medium returned">returned</span> <span class="ff-black">{{ getMetaTotal }}</span>
                            </span>
                            {{ $t("catalogue.results") }}
                        </div>
                        <div class="hidden">filters</div>
                    </header>
                    <section class="resultsWrapper flexContainer fw-w ">
                        <div class="row">
                            <ComponentListItem
                                :page="'catalogue'"
                                :key="item.id"
                                v-for="(item, index) in getVueResults"
                                :index="index"
                                :item="item"
                                :device="'mobile'"
                            ></ComponentListItem>
                        </div>
                    </section>
                    <div class="flexContainer jc-sb">
                        <div></div>
                        <div></div>
                        <div class="pagination center" v-if="getMetaTotalPage > 1">
                            <Pagination :componentName="'Catalog'" :meta="getMeta" :page="currentPage"></Pagination>
                        </div>
                    </div>
                </section>
            </section>
        </section>
        <section>
            <transition name="fade">
                <section id="filterMobile" class="mobileOnly" v-if="filterMobile">
                    <div class="flexContainer m-jc-sb t-jc-sb">
                        <button class="clear btn iBlock pointer">
                            <router-link
                                :class="{ active: this.$route.query.type || this.$route.query.category || this.$route.query.subcategory }"
                                to="/catalog"
                            >
                                {{ $t("catalogue.clear") }}
                            </router-link>
                        </button>
                        <div @click="closeFilters"><img src="../../assets/croix.png" width="28" height="28" alt="" /></div>
                    </div>
                    <section class="searchBar flexContainer fd-c">
                        <section class="composantsPickerWrapper">
                            <ul v-if="getLength('sections') > 1">
                                <li v-for="(item, index) in sections" :key="item.id">
                                    <router-link
                                        :to="{ name: 'Catalog', query: getLinkParams({ sections: item.id }) }"
                                        exact
                                        class="componentType"
                                        :class="{ active: sector === index }"
                                    >
                                        <span @click="closeFilters">{{ item.name }}</span></router-link
                                    >
                                </li>
                            </ul>
                        </section>
                        <section class="sectionPickerWrapper">
                            <ul>
                                <li v-for="(item, index) in types" :key="item.id" id="typeOfSector">
                                    <router-link
                                        :to="{ name: 'Catalog', query: getLinkParams({ type: item.id }) }"
                                        exact
                                        class="sectionType"
                                        :class="{ active: type === index }"
                                    >
                                        <span @click="closeFilters">{{ item.name }}</span></router-link
                                    >
                                </li>
                            </ul>
                        </section>
                        <section class="categoriesPickerWrapper">
                            <CategoryPicker
                                :categories="categories"
                                :getLinkParams="getLinkParams"
                                :hauteur="1"
                                :isActive="1"
                                @updateQuery="updateQuery"
                            ></CategoryPicker>
                        </section>
                        <section class="validFilters flexContainer m-fd-c m-jc-c">
                            <button class="btn ff-light center" @click="closeFilters">{{ $t("common.cancel") }}</button>
                            <button class="btn btn-dark ff-light center">{{ $t("common.finish") }}</button>
                        </section>
                    </section>
                </section>
            </transition>
        </section>
        <ForecastModal v-if="isForecastModalActive" :items="allResults.data" @close="isForecastModalActive = false;" />
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ModalBasket from "../modal/ModalBasket";
import Pagination from "./Pagination";
import loader from "../loader/loader";
import ComponentListItem from "../ComponentListItem/ComponentListItem";
import Picker from "@/components/catalog/picker";
import CategoryPicker from "@/catalog/category-picker";
import { FUNCTIONALITY } from "@/components/forecasts/constants";
import ForecastModal from "@/components/forecasts/elements/catalogue/MultiSelectModal";
import ForecastIcon from "@/components/forecasts/elements/icons/ForecastIcon";
import component from "@/services/component";

export default {
    components: {
        ForecastIcon,
        ModalBasket,
        Pagination,
        loader,
        ComponentListItem,
        Picker,
        CategoryPicker,
        ForecastModal
    },
    data: () => ({
        routeParams: {},
        searchResults: [],
        sector: null,
        type: null,
        filterMobile: false,
        types: [],
        sections: [],
        categories: [],
        standDesigns: [],
        systemTypes: [],
        displayBasket: false,
        currentPage: null,
        loader: false,
        isForecastModalActive: false,
        allResults: [],
        status: []
    }),
    watch: {
        $route(to, from) {
            this.currentPage = this.$route.query.offset;
            if (this.$route.query.offset === undefined) {
                this.$route.query.offset = 1;
            }
            this.updateQuery(to);
        }
    },
    methods: {
        ...mapActions("forecast", { populateForecasts: "populate" }),
        modalClose(close) {
            this.displayBasket = close;
        },
        getLinkParams(x) {
            const temp = {};
            for (let key in this.routeParams) {
                temp[key] = this.routeParams[key];
            }
            if (x.hasOwnProperty("category")) {
                delete temp.offset;
            } else if (x.hasOwnProperty("type") || x.hasOwnProperty("section")) {
                delete temp.offset;
            }

            for (let key in x) {
                temp[key] = x[key];
            }
            return temp;
        },
        getRouteParams() {
            return this._.omitBy(this.routeParams, (o, key) => {
                return key === "offset" && o === 1;
            });
        },
        setRouteParams(params) {
            let temp = {};
            for (let key in params) {
                if (key !== "url" && key !== "method") {
                    temp[key] = params[key];
                }
            }
            this.routeParams = temp;
        },
        updateQuery(to) {
            this.loader = true;
            this.setRouteParams(to.query);
            this.$store.dispatch("catalog/search/getResults", { routeParams: this.getRouteParams() }).then(() => {
                this.updateVueResults(this.getResults());
                this.loader = false;
            });
        },
        async addSelectionToForecasts() {
            this.loader = true;
            let res = await component.getAllResultsWithoutPagination(this.getRouteParams());
            this.loader = false;
            this.allResults = res;
            this.isForecastModalActive = true;
        },
        updateVueResults(datas) {
            this.searchResults = datas;
        },
        showFilters() {
            this.filterMobile = true;
        },
        closeFilters() {
            this.filterMobile = false;
        }
    },
    computed: {
        ...mapGetters({
            getBrandColor: "brand/getLinksColor"
        }),
        ...mapGetters("catalog/filters/", {
            getFilters: "getFilters",
            getLength: "getLength"
        }),
        ...mapGetters("catalog/search/", {
            getResults: "getResults",
            getMetaTotal: "getMetaTotal",
            getMeta: "getMeta",
            getMetaTotalPage: "getMetaTotalPage"
        }),
        getVueResults() {
            let datas = this.searchResults;
            datas.sort(function(a, b) {
                let date1 = new Date(a.modifiedDate);
                let date2 = new Date(b.modifiedDate);
                return date2.getTime() - date1.getTime();
            });
            return datas;
        },
        showForecastAddButton() {
            return this.hasForecastAccess && this.getVueResults.length > 0;
        },
        hasForecastAccess() {
            return this.hasAccessDelete(FUNCTIONALITY);
        }
    },
    created() {
        this.setRouteParams(this.$route.query);

        this.$store.dispatch("catalog/search/getResults", { routeParams: this.routeParams }).then(() => {
            this.updateVueResults(this.getResults(20));
        });
        this.$store.dispatch("catalog/filters/populate", { routeParams: {} }).then(() => {
            this.sections = this.getFilters("sections");
            this.categories = this.getFilters("categories");
            this.types = this.getFilters("types");
            this.systemTypes = this.getFilters("systemTypes");
            this.status = this.getFilters("status");
            this.standDesigns = this.getFilters("standDesigns");
        });

        if (this.hasForecastAccess) {
            this.populateForecasts();
        }
    }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/themes.scss";
.starMenu,
.filterMenu {
    & li {
        cursor: pointer;
        &.router-link-exact-active {
            color: $color2 !important;
            font-weight: bold;
            -webkit-transition: all 0.3s;
            transition: all 0.3s;
        }
    }
}

#catalog {
    .info-export-pdf {
        margin-top: 5px;
        display: inline-block;
        background-color: #5f5f5f;
        color: #fff;
        padding: 5px;
    }
    .btn-add-export {
        font-weight: bold;
    }
    .btn-add-export:hover {
        background-color: #c40505 !important;
    }
    margin-top: 10px;
    .searchBar {
        @extend %primary-bloc;
        padding: 25px;
        border-radius: 3px;
        ul {
            padding: 10px;
            margin: 10px;
            @extend %second-background;
            li {
                list-style: none;
                padding: 5px;
                margin: 0;
                text-transform: uppercase;
                font-size: 1.6rem;
                color: #999;
                &:hover {
                    @extend %primary-text;
                    transition: 0.2s;
                }
                &.active {
                    color: $color2;
                    font-weight: bold;
                    transition: all 0.3s;
                }
            }
        }
        .small {
            font-size: 1.1rem;
            background: none;
            text-decoration: none;
            border: 0;
            margin-left: 10px;
        }
    }
    .searchResultsWrapper {
        margin: 0 10px;
        border-radius: 3px;
        padding: 30px;
        @extend %primary-bloc;
        .queryResults {
            font-size: 1.6rem;
            text-transform: uppercase;
            .returned {
                @extend %primary-text;
            }
            .ff-light:last-child {
                .step {
                    display: none;
                }
            }
        }
        .resultsWrapper {
            padding-top: 30px;
        }
    }
}
.componentType {
    text-decoration: none;
}
.sectionType {
    text-decoration: none;
}
.clear {
    max-width: 121px;
    margin-left: 10px;
    text-decoration: none;
    text-decoration: none;
    color: #343434;
    white-space: nowrap;
    &:hover {
        transition: all 0.3s;
        color: #343434;
    }
    &.active {
        font-weight: 600;
        max-width: 121px;
    }
}
.pagination {
    .pageLink,
    page-link {
        font-size: 1.6rem;
        width: 20px;
        height: 20px;
        margin: 0 2px;
        text-align: center;
        text-decoration: none;
        color: #343434;
        &:hover {
            color: #343434;
        }
        &.active {
            color: rgb(200, 0, 0);
            font-weight: 700;
        }
    }
}
.arrowPag {
    margin-bottom: 4px;
}
@media only screen and (max-width: 767px) {
    .componentMobile {
        text-decoration: none;
        color: black;
    }
    #catalog {
        margin: 0px;
        padding-top: 30px;
        .catalogWrapper {
            .sortContainer {
                background-color: #f4f4f4;
                z-index: 5;
                padding-top: 60px;
                top: 105px;
                left: 0;
                .sortFilter {
                    font-size: 1.4rem;
                    .tri {
                        background-color: yellow;
                    }
                    p {
                        margin-top: 0px;
                        width: 50%;
                        text-align: center;
                        &:first-child {
                            // border-right:1px solid #e2e2e2;
                        }
                    }
                }
            }
            .searchResultsWrapper {
                flex-direction: column;
                -webkit-flex-direction: column;
                padding: 15px;
                margin-top: 50px;
                .queryResults {
                    font-size: 1.4rem;
                }
                .resultsWrapper {
                    h3 {
                        font-size: 1.4rem;
                        padding: 0 10px;
                    }
                }
            }
        }
        #typeOfSector {
            li {
                &.active {
                    color: #343434;
                    font-weight: 500;
                    border-bottom: 1px solid #343434;
                    transition: all 0.3s;
                }
            }
        }
        select {
            border: none;
        }
        .sort {
            font-size: 14px;
            font-family: Roboto;
        }
        .filterSelect {
            font-size: 14px;
            padding-left: 10px;
        }
    }
    #filterMobile {
        background: #fff;
        padding: 30px;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 10;
        display: block;
        .clear {
            margin-left: 0;
            max-width: 126px;
            a {
                text-decoration: none;
                color: #343434;
                &:hover {
                    color: #cc0000;
                }
                &.active {
                    font-weight: 600;
                }
            }
        }
        .searchBar {
            background-color: white;
            border-radius: 3px;
            ul {
                padding: 10px;
                background-color: #f4f4f4;
                li {
                    list-style: none;
                    padding: 5px;
                    margin: 0;
                    text-transform: uppercase;
                    font-size: 1.6rem;
                    a {
                        color: #bbb;
                        &.active {
                            color: #343434;
                            transition: all 0.3s;
                        }
                    }
                }
            }
            .composantsPickerWrapper {
                margin-top: 20px;
            }
        }
        .validFilters {
            margin-top: 20px;
            margin-bottom: 30px;
            button {
                width: 217px;
                font-size: 1.4rem;
                &:first-child {
                    margin-bottom: 10px;
                }
            }
        }
    }
}

@media only screen and (min-width: 768px) and (max-width: 1024px) {
    #catalog {
        .catalogWrapper {
            .sortContainer {
                left: 0;
            }
            .searchResultsWrapper {
                display: block;
                width: 100%;
                margin-top: 45px;
                z-index: 5;
            }
        }
    }
    #filterMobile {
        background: #fff;
        padding: 30px;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 10;
        .searchBar {
            display: block;
        }
        .clear {
            margin-left: 0;
            max-width: 126px;
            a {
                text-decoration: none;
                color: #343434;
                &:hover {
                    color: #cc0000;
                }
                &.active {
                    font-weight: 600;
                }
            }
        }
        .searchBar {
            background-color: white;
            border-radius: 3px;
            ul {
                padding: 10px;
                background-color: #f4f4f4;
                li {
                    list-style: none;
                    padding: 5px;
                    margin: 0;
                    text-transform: uppercase;
                    font-size: 1.6rem;
                    a {
                        color: #bbb;
                        &.active {
                            color: #343434;
                            transition: all 0.3s;
                        }
                    }
                }
            }
            .composantsPickerWrapper {
                margin-top: 20px;
            }
        }
        .validFilters {
            margin-top: 20px;
            margin-bottom: 30px;
            button {
                width: 217px;
                font-size: 1.4rem;
                &:first-child {
                    margin-bottom: 10px;
                }
            }
        }
    }
    .sortFilter {
        p {
            margin: 0 auto;
            padding-bottom: 15px;
            font-size: 1.4rem;
        }
    }
}
</style>



// WEBPACK FOOTER //
// Catalog.vue?c59f78de